import { Link } from 'react-router-dom';
import { Mic2 } from 'lucide-react';
import { LoginArea } from '@/components/auth/LoginArea';

export function Navbar() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/30 bg-background/80 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link to="/episodes" className="flex items-center gap-2 shrink-0 group">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center shadow-sm group-hover:shadow-purple-500/40 transition-shadow">
            <Mic2 className="w-3.5 h-3.5 text-white" />
          </div>
          <span className="font-bold text-base tracking-tight">
            Simply<span className="text-purple-500">Nostr</span>
          </span>
        </Link>

        {/* Account */}
        <LoginArea className="max-w-52" />
      </div>
    </header>
  );
}
